<template>
  <div class="vm-characteristic">
    <section class="vm-title-border">
      <div class="vm-title-headline">
        <span>Java前景</span> 
        <span>要培养就培养中级软件工程师</span>
      </div>
      <div class="vm-title-subhead">中级软件工程师不仅收入更高</div>
          <div class="vm-title-subhead">更是整个职业生涯正向循环的起点</div>
      
    </section>
    <section class="vm-characteristic-cont pd20">
      <img src="../../../assets/img/k_zj1.png" />
      <div class="vm-more theme_jb bgff"  @click="goMore()">做Java职业生涯更多规划&nbsp; ></div>
    </section>
  </div>
</template>

<script>
export default {

   data(){
    return{
        city: localStorage.getItem("city")
    }
  },
  methods:{
    goMore(){
        if (this.city == '2') {
        let _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/9002684/1";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
      } else if (this.city == '5') {
        let _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/10151581/1";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
      } else if (this.city == '1') {
        let _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/10159302/1";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
      } else if (this.city == '3') {
        let _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/10160432/1";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
      } else if (this.city == '4') {
        let _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/10179872/1";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
      } else if (this.city == '6') {
        let _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/10151577/1";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
      } else{
        let _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/9002684/1";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("../../../assets/css/comm.css");

@import url("../../../assets/css/title.css");
.vm-characteristic-cont img {
  width: 100%;
}
</style>